import { auth0Cfg, auth0Client } from '../Auth0SignIn/auth0Config';
import CookieLocalStorage from 'src/features/Auth/Login/CookieLocalStorage';
import SiteSettings from 'src/siteSetting';
import { ifElse, equals, always } from 'ramda';
import { LOG_OUT } from "src/route_constants";

export const clearCookieUserAndSSO = () => {
  clearCookieUser();
  clearSessionStorage();
  ifElse(
    equals(true),
    always(logoutSSO),
    always(logout)
  )(SiteSettings.plunginAuth0Enabled())();
};

//LOCAL PRIVATE//
const clearCookieUser = () => {
  CookieLocalStorage.deleteUser();
};
const clearSessionStorage = () => {
  sessionStorage.clear();
};

const logout = () => {
  /** send the user back to login */
  window.location.assign(LOG_OUT);
};

const logoutSSO = () => {
  try {
    return auth0Client.logout({
      clientID: auth0Cfg.clientID,
      returnTo: auth0Cfg.logoutRedirectUri,
      federated: true,
    });
  } catch (err) {
    //reportException(`<--------SSOLogout-39----------> ${err}`);
    logout()
  }
};
